import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoaderCustomFixed from "../../components/ConfirmationModal/LoaderCustomFixed";
import PopupLogin from "../../components/popuplogin/PopupLogin";

const ActivationPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [activationStatus, setActivationStatus] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const confirmationGuiId = params.get('confirmationId');

        if (confirmationGuiId) {
            activateNewUser(confirmationGuiId);
        }
    }, []);

    const activateNewUser = async (confirmationGuiId) => {
        setIsLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/User/activatenewuser`, {
                confirmationGuiId
            });
            if (response.status === 200 && response.data.success) {
                setActivationStatus('Registration was successful');
            } else {
                setActivationStatus('Registration was unsuccessful');
            }
        } catch (error) {
            setActivationStatus('Registration was unsuccessful');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
            {isLoading ? (
                <LoaderCustomFixed />
            ) : (
                <div style={{
                    padding: '40px',
                    backgroundColor: activationStatus === 'Registration was successful' ? '#28a745' : '#dc3545',
                    color: 'white',
                    fontSize: '1.25rem',
                    borderRadius: '10px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                    textAlign: 'center',
                    maxWidth: '600px',
                    width: '90%',
                    transition: 'transform 0.3s ease-in-out',
                }}>
                    {activationStatus === 'Registration was successful' ? (
                        <>
                            <div>თქვენ წარმატებით გაიარეთ რეგისტრაცია!</div>
                            <button
                                onClick={togglePopup}
                                style={{
                                    marginTop: 10,
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff', // Primary blue color
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease', // Smooth transition for hover effect
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                                }}
                                onMouseOver={({target}) => target.style.backgroundColor = '#0056b3'} // Darker blue on hover
                                onMouseOut={({target}) => target.style.backgroundColor = '#007bff'} // Revert to original on mouse out
                            >
                                პორტალში შესვლა
                            </button>
                        </>
                    ) : (
                        <div>დაფიქსირდა შეცდომა!</div>
                    )}
                </div>
            )}
            {isPopupOpen && <PopupLogin isOpened={isPopupOpen} onClose={togglePopup}/>}
        </div>
    );
};

export default ActivationPage;
